import {selectAnatomy as parts} from '@chakra-ui/anatomy';
import {useMultiStyleConfig} from '@chakra-ui/react';
import {createMultiStyleConfigHelpers, defineStyle} from '@chakra-ui/styled-system';

import {inputTheme} from './Input';

// Base styles
// https://github.com/chakra-ui/chakra-ui/blob/%40chakra-ui/react%402.8.1/packages/components/theme/src/components/select.ts

const {defineMultiStyleConfig, definePartsStyle} = createMultiStyleConfigHelpers(parts.keys);

const baseStyle = definePartsStyle({
  field: inputTheme.baseStyle?.field || {},
  icon: {},
  indicatorSeparator: {
    opacity: `0`,
  },
});

const iconSpacing = defineStyle({
  // paddingInlineEnd: `8`,
});

const sizes = {
  lg: {
    ...inputTheme.sizes?.lg,
    field: {
      ...inputTheme.sizes?.lg.field,
      ...iconSpacing,
    },
  },
  md: {
    ...inputTheme.sizes?.md,
    field: {
      ...inputTheme.sizes?.md.field,
      ...iconSpacing,
    },
  },
  sm: {},
};

export const selectTheme = defineMultiStyleConfig({
  baseStyle,
  sizes,
  variants: inputTheme.variants,
  defaultProps: inputTheme.defaultProps,
});

export const useSelectStyleConfig = (props: Parameters<typeof useMultiStyleConfig>[1]) =>
  useMultiStyleConfig(`Select`, props);
